<template>
  <div class="sign-in">
    <div class="sign-form">
      <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false">
        <p>You need to associate an e-mail</p>
        <van-field v-model="form.email" placeholder="E-mail" />
        <van-field v-model="form.code" placeholder="Code">
          <template #button>
            <span class="code" v-if="newTimer">{{ newCount || 0 }}s</span>
            <span class="sendcode code" v-else @click="getCode">get</span>
          </template>
        </van-field>
        <div class="vant-btn">
          <van-button round block type="info" native-type="submit">
            Submit
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Resetpassword",
  data() {
    return {
      form: {
        email: "",
        code: "",
      },
      newCount: 0,
      timer: null,
      newTimer: null,
      codeKey: "",
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      redirectUrl: "getRedirectUrl",
    }),
    path() {
      return this.$route.query.url;
    },
  },
  created() {
    console.log(this.path);
  },
  methods: {
    ...mapActions({
      sendEamilCode: "my/sendEamilCode",
      validateCode: "my/validateCode",
      putEmail: "my/putEmail",
    }),
    async onSubmit() {
      if (!this.validatorEamil(this.form.email)) {
        this.$toast.fail("error Eamil");
        return;
      }
      let checkRes = await this.Checkphone();
      if (!checkRes) {
        return;
      }
      let body = {
        memberId: this.userInfo.inMember.memberId,
        email: this.form.email,
      };
      let res = await this.putEmail(body);
      if (res.result) {
        this.$toast.success("success");
        let path = encodeURIComponent(this.path);
        this.next(path);
      } else {
        this.$toast.fail("the account is already associated");
      }
    },
    next(path) {
      if (path === "/auth" || path === "/") {
        let url = location.origin + "/home";
        let redirectUrl = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", url);
        this.$store.commit("wxShare/setUrl", url);
        window.url = redirectUrl || url;
        console.log("!!!!!!!!!!!! 2-存入地址：", url);

        var myURL = new URL(redirectUrl || url);
        // this.$store.commit("setRedirectUrl", "");
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl || url;
      } else {
        let pa = location.origin + path;
        let redirectUrl2 = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", pa);
        this.$store.commit("wxShare/setUrl", pa);
        window.url = redirectUrl2 || pa;
        // this.$store.commit("setRedirectUrl", "");
        console.log("!!!!!!!!!!!! 3-存入地址：", pa);

        var myURL = new URL(redirectUrl2 || url);
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl2 || pa;
      }
    },
    // 邮箱验证
    validatorEamil(val) {
      return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
    },
    // 获取手机号验证码
    async getCode() {
      console.log(this.form.email, "123213");
      if (!this.validatorEamil(this.form.email)) {
        this.$toast.fail("error Eamil");
        return;
      } else {
        this.newDownTime();
        let res = await this.sendEamilCode({
          email: this.form.email,
        });
        if (res.result) {
          this.$toast.success("send success");
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail("fail");
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.form.code,
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail("Validation failed");
          this.resetDown();
          resolve(false);
        }
      });
    },

    resetDown() {
      // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.form.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sign {
  &-form {
    margin: 1.4rem 0.3rem 0;
    .vant-btn {
      margin-top: 0.5rem;
      span {
        font-size: 0.3rem;
      }
    }
    .code {
      font-size: 0.3rem;
      color: #0190fe;
    }
    p {
      font-size: 0.24rem;
      color: #999;
      text-align: center;
      margin: 0.4rem 0;
    }
  }
}
</style>
